import { Link } from '@tanstack/react-router';
import type { PermissionKey } from '@bm/contracts';
import { useAuth } from '../lib/auth';
import { Card } from '../components/ui';
import { DEFAULT_NAV_ICONS, resolveIcon } from '../lib/nav-icons';

const QUICK_LINKS: Array<{ to: string; key: string; label: string; perm: PermissionKey }> = [
  { to: '/members', key: 'members', label: 'Mitglieder', perm: 'members.view' },
  { to: '/training', key: 'training', label: 'Training', perm: 'training.view' },
  { to: '/season', key: 'season', label: 'Saison', perm: 'season.view' },
  { to: '/calendar', key: 'calendar', label: 'Kalender', perm: 'calendar.view' },
  { to: '/equipment', key: 'equipment', label: 'Equipment', perm: 'equipment.view' },
];

export function DashboardPage() {
  const { me, can } = useAuth();
  const active = me?.memberships.find((m) => m.organizationId === me.activeOrganizationId);
  const links = QUICK_LINKS.filter((l) => can(l.perm));

  return (
    <div className="space-y-4">
      <h1 className="text-xl font-semibold">
        Hallo{me?.user.firstName ? `, ${me.user.firstName}` : me?.user.email ? `, ${me.user.email}` : ''}
      </h1>
      <Card title="Aktive Organisation">
        {active ? (
          <p className="text-sm text-slate-600">
            {active.organizationName} — Rolle: {active.roleName ?? '—'}
          </p>
        ) : (
          <p className="text-sm text-slate-600">Keine Organisation ausgewählt.</p>
        )}
      </Card>
      {active?.status === 'pending_approval' && (
        <Card title="Warten auf Freischaltung">
          <p className="text-sm text-slate-600">
            Deine Registrierung bei {active.organizationName} wurde übermittelt, wartet aber noch
            auf die Freigabe durch einen Vereinsadministrator. Sobald das passiert ist, siehst du
            hier die normalen Vereinsfunktionen.
          </p>
        </Card>
      )}
      {links.length > 0 && (
        <Card title="Schnellzugriff">
          <div className="flex flex-wrap gap-2">
            {links.map((l) => {
              const Icon = resolveIcon(DEFAULT_NAV_ICONS[l.key]);
              return (
                <Link
                  key={l.to}
                  to={l.to}
                  className="flex items-center gap-2 rounded-md border border-slate-200 px-3 py-2 text-sm text-slate-700 hover:bg-slate-50"
                >
                  <Icon size={16} className="shrink-0 text-brand-accent" />
                  {l.label}
                </Link>
              );
            })}
          </div>
        </Card>
      )}
    </div>
  );
}
